IREP.Blog = (function () {
    "use strict";

    var init = function () {

        initDropBox();
        insertBlog();
        setDateTimePicker();
    };

    var initDropBox = function () {
        var dropbox = $('#dropbox'),
            message = $('.message', dropbox);

        dropbox.filedrop({
            paramname: 'pic',
            maxfiles: 1,
            maxfilesize: 2, //in MB
            url: '/apac/photoshare/PhotoShareUpload', //Uses PhotoshareUpload.aspx in the pages\photoshare directory. 

            uploadFinished: function (i, file, response) {
                //Upon upload completion, we want to hide the drop area and show the cropper control. 
                $.data(file).addClass('done');

                //!!! To do: Add next step. 
                //showCropper(response[1], response[2]);
            },

            error: function (err, file) {
                switch (err) {
                    case 'BrowserNotSupported':
                        //showMessage(_options.ErrorBrowserNotSupported);
                        break;
                    case 'TooManyFiles':
                        //alert(_options.ErrorTooManyFiles);
                        break;
                    case 'FileTooLarge':
                        //alert(file.name + _options.ErrorFileTooLarge);
                        break;
                    default:
                        break;
                }
            },

            //Function renders a progress indicator for uploads.
            uploadStarted: function (i, file, len) {

                //if (checkFileName(file.name)) {
                createImage(file);
                //}
                //else {
                //    alert(_options.InvalidFileDetails);
                //    return false;
                //}

            },

            //Updates the progress bar. 
            progressUpdated: function (i, file, progress) {
                $.data(file).find('.progress').width(progress);
            }

        });
    }

    //Holder for images being uploaded. 
    var template = '<div class="preview">' +
                        '<span class="imageHolder">' +
                            '<img />' +
                            '<span class="uploaded"></span>' +
                        '</span>' +
                        '<div class="progressHolder">' +
                            '<div class="progress"></div>' +
                        '</div>' +
                    '</div>';

    function createImage(file) {

        var preview = $(template),
            image = $('img', preview);

        var reader = new FileReader();

        image.width = 200;
        image.height = 200;

        reader.onload = function (e) {

            // e.target.result holds the DataURL which
            // can be used as a source of the image:
            //alert(e.target.result);
            image.attr('src', e.target.result);
        };

        // Reading the file as a DataURL. When finished,
        // this will trigger the onload function above:
        reader.readAsDataURL(file);

        message.hide();
        preview.appendTo(dropbox);

        // Associating a preview container
        // with the file, using jQuery's $.data():

        $.data(file, preview);
    }


    

    return {
        init: init
    };


})();






